import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 16.5 16.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6 2.25V.75m4.5 13.5v1.5M2.25 6H.75m13.5 4.5h1.5M2.936 2.936 1.875 1.875m11.69 11.69 1.06 1.06M8.25 12.493l-1.591 1.59a3 3 0 1 1-4.243-4.242L4.007 8.25m8.486 0 1.59-1.591a3 3 0 1 0-4.242-4.243L8.25 4.007"
    }, null, -1)
  ]))]))
}
export default { render: render }